<template>
  <div class="containter">
    <div class="board curved-0">
      <h5>
        ● Board - full-width, white background by default, no curved corners
      </h5>

      <sym-combo
        plain
        vertical
        align="bottom"
        v-model="regionId"
        caption="Region"
        display-field="regionFullName"
        :datasource="regions"
        @changing="onRegionIdChanging"
        @changed="onRegionIdChanged()"
      ></sym-combo>

      <button
        type="button"
        class="border-main shadow mb-0"
        title="get web data"
        @click="onButtonWebDataClick"
      >
        <i class="fa fa-upload mr-2"></i> Get WebData
      </button>
      <button
        type="button"
        class="border-main shadow mb-0"
        title="get web data"
        @click="onButtonRegionDataClick"
      >
        <i class="fa fa-upload mr-2"></i> Get RegionData
      </button>

      <sym-alert class="info-light" v-show="isLoaded">
        <span>This is an alert with 'info-light' color</span>
      </sym-alert>
    </div>

    <div class="white lg-1" v-show="regionId">{{ regionId }}</div>

    <sym-card
      class="lams-light curved-1"
      headerClass="lg-1 text-center bold"
      bodyClass="p-1 pb-2"
      v-show="apps"
    >
      <p slot="header" class="lg-2">Field Office</p>
      <ul>
        <li
          class="list-item text-dark"
          v-for="(app, index) in apps"
          :key="index"
        >
          <div class="d-flex justify-between align-items-center lg-1">
            <span>{{ app.officeId }} ● {{ app.officeName }}</span>
          </div>
        </li>
      </ul>
    </sym-card>
  </div>
</template>

<script>
import { get } from "../../js/http";

import * as lams from "../../js/lams";

import PageBase from "../PageBase.vue";

export default {
  extends: PageBase,
  name: "lms7090",

  data() {
    return {
      apps: [],
      regions: [],
      isLoaded: false,
      regionId: 0,
    };
  },

  computed: {},

  methods: {
    onRegionIdChanging(e) {
      const me = this;

      let regionInfo = me.regions.find(
        (obj) => obj.regionId === e.proposedValue
      );
      e.message = `Region '${regionInfo.regionFullName}' is offline.`;

      if (!regionInfo.apiHostAddress && regionInfo.regionId) {
        e.preventDefault();
        return;
      }

      if (e.proposedValue) {
        e.callback = me.regionIdCallback;
      }
    },

    onRegionIdChanged() {
      // console.log(this.regionId)
    },

    onButtonWebDataClick() {
      const me = this;

      me.isLoaded = true;

      // me.getWebData().then(
      //   apps => {
      //     me.stopWait(wait);
      //     me.apps = apps;

      //   },
      //   fault => {
      //     me.stopWait(wait);
      //     me.showFault(fault);
      //   }
      // );
    },

    onButtonRegionDataClick() {
      const me = this,
        wait = me.wait();

      me.getRegionData().then(
        (apps) => {
          me.stopWait(wait);
          me.apps = apps;
          // console.log(me.apps);
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    getWebData() {
      return get("api/web-data");
    },

    getRegionData() {
      return get("api/rgn/" + this.regionId + "/region-data");
    },
  },

  mounted() {
    const me = this;

    me.regions = lams.getRegionList().filter((o) => o.apiHostAddress);
  },
};
</script>

<style scoped></style>
